import { Component } from '@angular/core';
import { Validators, UntypedFormBuilder } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { DataDogService } from 'src/app/core/services/datadog.service';
import { datadogRum } from '@datadog/browser-rum';

@Component({
    selector: 'atlas-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.less'],
    standalone: false
})
export class LoginComponent {
  hide = true;
  loginForm = this.fb.group({
    email: [
      '',
      Validators.compose([
        Validators.required,
        Validators.pattern(
          '^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}'
        )
      ])
    ],
    password: ['', Validators.required]
  });

  constructor(
    private fb: UntypedFormBuilder,
    public authService: AuthService,
    private dataDogService: DataDogService
  ) {}
  onLogin() {
    const durationName = 'login_button';
    datadogRum.startDurationVital(durationName);

    this.dataDogService.trackUserAction(
      'login_button_clicked',
      {
        component: 'LoginComponent',
        button: 'login_button',
        value: this.loginForm.controls.email.value
      },
      durationName
    );

    this.authService.login(
      this.loginForm.controls.email.value,
      this.loginForm.controls.password.value
    );
  }
  onResetPassword() {
    this.authService.forgotPassword();
  }
  invalidEmail() {
    return (
      this.loginForm.controls.email.invalid ||
      (this.loginForm.controls.email.errors &&
        (this.loginForm.controls.email.errors.required ||
          this.loginForm.controls.email.errors.pattern))
    );
  }

  emptyPassword() {
    return (
      this.loginForm.controls.password.errors &&
      this.loginForm.controls.password.errors.required
    );
  }

  public showSignup() {
    this.authService.setAuthAction('signup');
  }
}
